import React from 'react';
import * as t from 'io-ts'
import './styles.css';  // Import the CSS file
import useLocalStorage from 'ui-io/use-local-storage';
import { openPricingDialog } from "ui-io/stores/pricing-store";
// import { setDataInLocalStorage } from 'ui-io/utils/local-storage';
const PremiumBanner = () => {
  const [premiumBannerDisable, setPremiumBannerDisable] = useLocalStorage(
    'premium-banner',
    localStorage.getItem('premium-banner') === 'true',
    t.boolean as t.Type<boolean, unknown, unknown>
  )
  const handleClose = ()=>{
    setPremiumBannerDisable(true)
  }
  return (
    
    <>
    {!premiumBannerDisable && <div className="banner display-flex mb-lg">
      
       
      <div className="image-container"> <img 
          src="/images/premium-banner-left.svg" // Replace with your image path
          alt="Premium features" 
        /></div>
       <div className="text-container">
        <p>Access all advanced features with Premium</p>
        <button className="upgrade-button" onClick={openPricingDialog}>Upgrade Now</button>
        </div>
      <div className="right-image-container mr-50">
        <img 
          src="/images/premium-banner.svg" // Replace with your image path
          alt="Premium features" 
        />
      </div>

      <div className="close" onClick={handleClose}>
        <img 
          src="/icons/close.svg" // Replace with your image path
          alt="Close" 
        />
      </div>
    </div>
    }
    </>
  );
};

export default PremiumBanner;
